/**
 * @generated SignedSource<<64d77e634748415af4181b7738ddc071>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationNewsfeedScreenDeleteMutation$variables = {
  id: string;
};
export type IntegrationNewsfeedScreenDeleteMutation$data = {
  readonly store: {
    readonly deleteIntegrationNewsfeed: boolean | null;
  };
};
export type IntegrationNewsfeedScreenDeleteMutation = {
  response: IntegrationNewsfeedScreenDeleteMutation$data;
  variables: IntegrationNewsfeedScreenDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ScalarField",
        "name": "deleteIntegrationNewsfeed",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationNewsfeedScreenDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationNewsfeedScreenDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "df76f1960a16d7892227b147915a9214",
    "id": null,
    "metadata": {},
    "name": "IntegrationNewsfeedScreenDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationNewsfeedScreenDeleteMutation(\n  $id: ID!\n) {\n  store {\n    deleteIntegrationNewsfeed(id: $id)\n  }\n}\n"
  }
};
})();

(node as any).hash = "dbbe062b5aba03e0de98ad5ef9ed7c79";

export default node;
